import Vue from "vue";
import DatetimeHelper from "~/helpers/datetimeHelper";
import moment from 'moment-timezone';

export default Vue.extend({
  computed: {
    url() {
      return this.attachment.url;
    },
    filename() {
      return this.attachment.filename;
    },
    fileType() {
      const split = this.attachment.filename.split('.');
      const length = split.length;
      return split[length - 1].toUpperCase();
    },
    fileSize() {
      return this.attachment.file_size;
    },
    uploadDate() {
      const timeZone = moment.tz.guess();
      const format = 'MMMM D, YYYY'; // Ex. May 14, 2020
      const parsedDate = DatetimeHelper.parseDate(this.attachment.c_at, timeZone, format);
      return DatetimeHelper.formatDate(parsedDate, timeZone, format);
    }
  }
});